import React, { Component } from 'react';
import './MyBookingPage.css';

// Phase 2 & 3 - Dependencies implemented
import AppointmentStatus from '../../../components/AppointmentStatus';
import ProhibitedIcon from '../../../components/ProhibitedIcon';
import { connect } from 'react-redux';
import GetMyAppointmentsActions from '../../../redux/GetMyAppointmentsRedux';
import { withTranslation } from 'react-i18next';
import { ArrowLeft } from '../../../assets/icons';
import ConfirmBox from '../../../components/ConfirmBox';

// TODO: Phase 2 - Uncomment when SVG icons are converted
// import { ArrowLeft } from '../../assets/icons';

// TODO: Phase 2 - Uncomment when moment is available
// import moment from 'moment';

interface MyBookingPageState {
  // Phase 4 - Component logic implemented
  upcomingAppointments: any[];
  previousAppointments: any[];
  loading: boolean;
  confirmPopupOpen: boolean;
}

interface MyBookingPageProps {
  // Phase 2 & 3 - Props implemented
  navigation?: any;
  t?: (key: string) => string;
  getMyAppointments?: () => void;
  getMyAppointmentsFetching?: boolean;
  getMyAppointmentsSuccess?: boolean;
  getMyAppointmentsError?: boolean;
  appointments?: any[];
}

class MyBookingPage extends Component<MyBookingPageProps, MyBookingPageState> {
  constructor(props: MyBookingPageProps) {
    super(props);
    this.state = {
      // Phase 4 - Component logic implemented
      upcomingAppointments: [],
      previousAppointments: [],
      loading: false,
      confirmPopupOpen: false
    };
  }

  componentDidMount() {
    // Match reference: No API call in componentDidMount
    console.log('MyBookingPage mounted');

    if ( this.props.getMyAppointments ) {
      this.props.getMyAppointments();
    }

  }

  // Phase 4 - Component logic implemented
  componentWillUnmount() {
    // Handle cleanup if needed
  }

  // Phase 4 - Navigation logic implemented
  handleAndroidBackPress = () => {
    this.props.navigation?.goBack();
    return true;
  }

  // Phase 4 - Navigation logic implemented
  back() {
    this.props.navigation?.goBack();
  }

  // Phase 4 - Cancel logic implemented (matching reference)
  _onCancelPress() {
    const { t } = this.props;
    
    // Match reference: Use proper alert dialog with translation keys
    const message = t?.('my-booking-screen:alert.message') || 'If you want to change or cancel booking, please contact our staff';
    const emailUsText = t?.('my-booking-screen:alert.button.email-us') || 'Email Us';
    const okText = t?.('alert:ok') || 'OK';

    this.setState({ confirmPopupOpen: true });
    /*
    
    // Create custom alert dialog to match reference behavior
    const userChoice = window.confirm(`${message}\n\nClick OK to email us, or Cancel to dismiss.`);
    
    if (userChoice) {
      // User clicked OK - open email
      window.open('mailto:info@cdchk.org', '_blank');
    }
    */
    // If user clicked Cancel, do nothing (matches reference behavior)
  }

  // Phase 4 - Appointment filtering logic implemented
  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (prevState.props) {
      if (!nextProps.getMyAppointmentsFetching) {
        if (nextProps.getMyAppointmentsSuccess) {
          let upcoming = nextProps.appointments.filter((obj: any) => !obj.is_past);
          let previous = [...nextProps.appointments.filter((obj: any) => obj.is_past)];
          previous.forEach((element: any, index: number) => {
            if (element.status === 'confirmed') {
              previous[index] = {
                id: element.id,
                child_name: element.child_name,
                category_name: element.category_name,
                status: 'completed',
                is_past: element.is_past,
                timeslot_date: element.timeslot_date,
                timeslot_time: element.timeslot_time
              };
            }
          });
          return {
            upcomingAppointments: upcoming,
            previousAppointments: previous,
          };
        }
      }
    }
    return {
      props: nextProps
    };
  }

  render() {
    const { loading, upcomingAppointments, previousAppointments } = this.state;
    const { getMyAppointmentsFetching, t } = this.props;

    return (
      <div className="mybooking-page">
        {/* Header Section */}
        <div className="page-header">
          <div className="page-header-inner">
            <div className="header-left">
              <button 
                className="header-button back-button"
                // Phase 4 - Navigation logic implemented
                onClick={() => this.back()}
              >
                {/* TODO: Phase 2 - Uncomment when ArrowLeft icon is available */}
                {/* <ArrowLeft /> */}
                <ArrowLeft />
              </button>
              <h1 className="header-title">
                {/* Phase 2 - Translations implemented */}
                {t?.('my-booking-screen:title') || 'My Booking'}
              </h1>
            </div>
            <div className="header-right">
              <button 
                className="cancel-button header-button"
                // Phase 4 - Cancel logic implemented
                onClick={() => this._onCancelPress()}
              >
                {/* Phase 2 - Translations implemented */}
                {t?.('my-booking-screen:header.right') || 'Cancel'}
              </button>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="mybooking-content">
          {/* Phase 4 - Complete appointment logic implemented */}
          {getMyAppointmentsFetching ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>{t?.('my-booking-screen:loading') || 'Loading appointments...'}</p>
            </div>
          ) : !upcomingAppointments.length && !previousAppointments.length ? (
            /* Empty State */
            <div className="no-booking-container">
              <ProhibitedIcon size={64} />
              <p className="no-booking-text">
                {t?.('my-booking-screen:message.no-booking') || 'No bookings found'}
              </p>
            </div>
          ) : (
            /* Appointments Lists */
            <div className="appointments-container">
              <div className="appointments-section">
                <h2 className="section-header">
                  {t?.('my-booking-screen:section.upcoming') || 'Upcoming Appointments'}
                </h2>
                {upcomingAppointments.length ? (
                  <div className="appointments-list">
                    {upcomingAppointments.map((appointment) => (
                      <div key={appointment.id} className="appointment-item">
                        <div className="appointment-status">
                          <AppointmentStatus status={appointment.status} />
                        </div>
                        <div className="appointment-details">
                          <h3 className="appointment-title">
                            {appointment.category_name}
                          </h3>
                          <p className="appointment-date">
                            {/* TODO: Phase 2 - Uncomment when moment is available */}
                            {/* {moment(new Date(appointment.timeslot_date)).format('dddd, MMMM DD, YYYY')} */}
                            {new Date(appointment.timeslot_date).toLocaleDateString('en-US', { 
                              weekday: 'long', 
                              year: 'numeric', 
                              month: 'long', 
                              day: 'numeric' 
                            })}
                          </p>
                          <p className="appointment-time">
                            {appointment.timeslot_time}
                          </p>
                          <p className="appointment-name">
                            {appointment.child_name}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-appointments">
                    <p>{t?.('my-booking-screen:message.no-booking') || 'No upcoming appointments'}</p>
                  </div>
                )}
              </div>

              <div className="appointments-section">
                <h2 className="section-header">
                  {t?.('my-booking-screen:section.previous') || 'Previous Appointments'}
                </h2>
                {previousAppointments.length ? (
                  <div className="appointments-list">
                    {previousAppointments.map((appointment) => (
                      <div key={appointment.id} className="appointment-item previous">
                        <div className="appointment-status">
                          <AppointmentStatus status={appointment.status} />
                        </div>
                        <div className="appointment-details">
                          <h3 className="appointment-title previous-text">
                            {appointment.category_name}
                          </h3>
                          <p className="appointment-date previous-text">
                            {/* TODO: Phase 2 - Uncomment when moment is available */}
                            {/* {moment(new Date(appointment.timeslot_date)).format('dddd, MMMM DD, YYYY')} */}
                            {new Date(appointment.timeslot_date).toLocaleDateString('en-US', { 
                              weekday: 'long', 
                              year: 'numeric', 
                              month: 'long', 
                              day: 'numeric' 
                            })}
                          </p>
                          <p className="appointment-time previous-text">
                            {appointment.timeslot_time}
                          </p>
                          <p className="appointment-name previous-text">
                            {appointment.child_name}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-appointments">
                    <p>{t?.('my-booking-screen:message.no-booking') || 'No previous appointments'}</p>
                  </div>
                )}
              </div>
            </div>
          )}


        </div>
        <ConfirmBox
          title={t?.('my-booking-screen:alert.title') || 'Message'}
          message={t?.('my-booking-screen:alert.message') || 'Are you sure you want to confirm this booking?'}
          confirmAction={() => {
            this.setState({ confirmPopupOpen: false })
            window.open('mailto:info@cdchk.org', '_blank');
          }}
          cancelAction={() => {
            this.setState({ confirmPopupOpen: false })
          }}
          cancelText={t?.('common:ok') || 'OK'}
          confirmText={t?.('my-booking-screen:alert.button.email-us') || 'Email Us'}
          isVisible={this.state.confirmPopupOpen}
          onClose={() => {}}
        />
      </div>
    );
  }
}

// Phase 2 & 3 - Redux and translations implemented
const mapStateToProps = (state: any) => {
  return {
    getMyAppointmentsFetching: state.getMyAppointments.fetching,
    getMyAppointmentsSuccess: state.getMyAppointments.success,
    getMyAppointmentsError: state.getMyAppointments.error,
    appointments: state.getMyAppointments.appointments,
    // appointments: [], // check empty state
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getMyAppointments: () => {
      dispatch(GetMyAppointmentsActions.getMyAppointmentsRequest());
    }
  };
};

// Phase 2 & 3 - Translations and Redux ready
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(MyBookingPage));
